import { FC } from "react";
import SelectComponent from "react-select";

import clsx from "clsx";

import ArrowIcon from "../../../assets/icons/chevron.svg";

import styles from "./select.module.scss";

interface ISelectProps {
  isShowPlaceholder?: boolean;
  isDifStyles?: boolean;
  menuPlacement?: any;
  defaultValue?: any;
  propsChange?: any;
  placeholder?: any;
  className?: any;
  options?: any;
  value?: any;
  name?: string;
  fullWidth?: boolean;
  disabled?: boolean;
  span?: string;
  style?: {[key: string]: string};
  isHotlineChanged?: boolean;
  isSearchable?: boolean;
}

const Select: FC<ISelectProps> = ({
                                    isShowPlaceholder,
                                    menuPlacement,
                                    defaultValue,
                                    isDifStyles,
                                    propsChange,
                                    placeholder,
                                    className,
                                    options,
                                    value,
                                    name,
                                    fullWidth = false,
                                    disabled,
                                    span,
                                    style,
                                    isHotlineChanged,
                                    isSearchable = false,
                                  }) => {
  const customStyles = {
    control: (provided: any) => ({
      ...provided,
      border: isDifStyles ? "none" : provided.border,
      borderRadius: "8px",
      flexWrap: "nowrap",
      fontWeight: "400",
      backgroundColor: disabled ? 'rgba(239, 239, 239, 0.3)' : "var(--background-input-color)",
      color: disabled && 'rgb(84, 84, 84)',
      borderColor: isHotlineChanged ? "#FF0000" : "#babbcc",
      boxShadow: 'none',
      ":hover": {
        borderColor: isHotlineChanged ? "#FF0000" : "#babbcc",
        boxShadow: 'none'
      },
      ":focus": {
        borderColor: isHotlineChanged ? "#FF0000" : "#babbcc",
      },
      width: style && style.width,
      height: style && style.height,
      marginBottom: style && style.margin,
    }),
    menu: (base: any) => ({
      ...base,
      minWidth: "100%",
      width: "max-content",
      backgroundColor: "var(--background-input-color)",
    }),
    menuList: (base: any) => ({
      ...base,
      maxHeight: "447px",
      "::-webkit-scrollbar": {
        background: "none",
        width: "8px",
      },
      "::-webkit-scrollbar-track": {
        background: "none",
      },
      "::-webkit-scrollbar-thumb": {
        backgroundColor: "var(--main-color)",
        border: "0px solid rgba(24, 24, 24, 0.795)",
        borderRadius: "8px",
      },
    }),
    option: (base: any, state: any) => ({
      ...base,
      fontSize: "14px !important",
      fontWeight: "400 !important",
      height: "fit-content",
      padding: "3px 10px",
      backgroundColor: state.isSelected ? "var(--main-color)" : "var(--background-input-color)",
      color: state.isSelected ? "var(--active-tab-color)" : "var(--text-color)",
      ":hover": {
        backgroundColor: state.isSelected
          ? "var(--main-color)"
          : "var(--table-head-bg-color)",
        color: state.isSelected
          ? "#fff"
          : "var(--main-color)",
      },
    }),
    indicatorSeparator: (base: any, state: any) => ({
      display: 'none'
    }),
    menuPortal: (base: any) => ({...base, zIndex: 999999}),
    placeholder: () => ({
      gridArea: '1/1/2/3',
      color: className.includes('changed') ? 'rgb(228, 53, 53)' : "var(--text-color)",
      fontWeight: className.includes('changed') ? '500' : '400',
      fontSize: '13px',
      lineHeight: '15px',
      marginLeft: '2px',
      marginRight: '2px',
      width: '90%',
      whiteSpace: 'nowrap' as const,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    }),
    singleValue: () => ({
      gridArea: '1/1/2/3',
      color: "var(--text-color)",
      fontSize: '13px',
      lineHeight: '15px',
      marginLeft: '2px',
      marginRight: '20px',
      width: '90%',
      whiteSpace: 'nowrap' as const,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    })
  };
  const DropdownIndicator = () => {
    return (
      <div>
        <img src={ArrowIcon} alt="Custom Indicator" className={clsx(styles.icon, disabled && styles.icon__disabled)} />
      </div>
    )
  };
  
  const customComponents = {
    DropdownIndicator,
  };
  return (
    <div className={clsx(styles.custom__select_wrapper, fullWidth && styles.fullWidth)} style={style}>
      <span
        className={clsx(styles.custom__floating_placeholer, isShowPlaceholder && styles.active__floating_placeholder, disabled && styles.active__floating_placeholder_disabled)}>
        {span}
      </span> <SelectComponent
      menuPortalTarget={document.body}
      components={customComponents}
      menuPlacement={menuPlacement || "auto"}
      onChange={(e) => propsChange(e)}
      defaultValue={defaultValue}
      placeholder={placeholder}
      className={className}
      styles={customStyles}
      isSearchable={isSearchable}
      options={options}
      value={value}
      name={name}
      isDisabled={disabled}
      {...({ isHotlineChanged } as any)}
    />
    </div>
  );
};

export default Select;
